<template>
  <div class="app-shell">
    <!-- Mobile hamburger button (non-module1 routes only) -->
    <button
      v-if="isLogged && $route.name !== 'LoginView' && !isModule1Route && isMobileView"
      class="mob-hamburger"
      @click="mobileSidebarOpen = !mobileSidebarOpen"
      aria-label="Open navigation"
    >
      <svg v-if="!mobileSidebarOpen" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
      <svg v-else width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
    </button>

    <!-- Mobile backdrop -->
    <div
      v-if="mobileSidebarOpen && !isModule1Route"
      class="mob-nav-backdrop"
      @click="mobileSidebarOpen = false"
    ></div>

    <app-sidebar
      v-if="isLogged && $route.name !== 'LoginView' && !isModule1Route"
      :class="{ 'mobile-open': mobileSidebarOpen }"
      @widthChange="sidebarWidth = $event"
      @mobileToggle="mobileSidebarOpen = $event"
    />
    <div class="app-content forBlind" :style="isLogged && $route.name !== 'LoginView' && !isModule1Route ? { marginLeft: isMobileView ? '0px' : sidebarWidth + 'px' } : {}">
      <router-view class="forBlind" />
    </div>
  </div>
</template>

<script>
import AppSidebar from "../../main/layout.main/sidebar.layout/AppSidebar";
import { mapState, mapGetters, mapActions } from "vuex";
import store from "../../store";
import UsersPermissionCheck from "../../mixins/user/auth/UsersPermissionCheck";
import moment from "moment";

export default {
  name: "App",
  components: {
    "app-sidebar": AppSidebar
  },
  mixins: [UsersPermissionCheck],
  data() {
    return {
      position: "center",
      duration: 4000,
      isInfinity: false,
      cost: "",
      sidebarWidth: typeof window !== 'undefined' && window.innerWidth < 768 ? 0 : 52,
      mobileSidebarOpen: false,
      isMobileView: typeof window !== 'undefined' && window.innerWidth < 768
    };
  },

  computed: {
    ...mapState("clients", [
      "tabsList",
      "salesPersonList",
      "ForTitleInfo",
      "ColorBlind"
    ]),
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapGetters("clients", ["loading"]),
    ...mapActions("clients", ["dynamicTitleInfo"]),
    ...mapActions("system", ["getSystemDictionary"]),
    isModule1Route() {
      return /\/(clients1|tasks1|shifts1|stats1|users1|finance1|brokers1|chat1|security1|communications1|affiliation1|games1|quiz1|settings1|instruction1|profile1)(\/|$)/.test(this.$route.path);
    }
  },

  beforeMount() {
    store.dispatch("user/getProfile");
    store.dispatch("system/getSystemDictionary");
    // this.$store.dispatch("clients/dynamicTitleInfo");
  },
  watch: {
    ColorBlind: function() {
      if (this.ColorBlind) {
        $(".forBlind").addClass("blind");
      } else {
        $(".forBlind").removeClass("blind");
      }
    },
    ForTitleInfo: function() {
      document.title =
        this.kFormatter(this.ForTitleInfo[0]) +
        " " +
        "|" +
        " " +
        this.kFormatter(this.ForTitleInfo[1]) +
        " " +
        "|" +
        " " +
        this.kFormatter(this.ForTitleInfo[2]) +
        " " +
        "AstraQ";
    }
  },
  created() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', () => {
        this.isMobileView = window.innerWidth < 768;
        if (!this.isMobileView) this.mobileSidebarOpen = false;
      });
    }
  },
  mounted() {
    // window.onbeforeunload = function(e) {
    //   let storage = window.localStorage;
    //   // storage.clear() /// removeing all localStorage
    //
    //   storage.removeItem("user-token"); ///removing only user-token
    // };

    // if (localStorage.getItem("user-token-login-time") !== null) {
    //   let tokenLogInTime = localStorage.getItem("user-token-login-time");
    //   let now = moment();
    //   let duration = moment.duration(moment(now).diff(tokenLogInTime));
    //   let minutes = duration.asMinutes();
    //   if (minutes > 30) {
    //     window.onbeforeunload = function(e) {
    //       let storage = window.localStorage;
    //       storage.removeItem("user-token"); ///removing only user-token
    //       storage.removeItem("user-token-login-time"); ///removing only user-token-login-time
    //     };
    //   }
    // }

    setInterval(() => {
      if (this.CheckUserPermission([1, 2, 3])) {
        this.$store.dispatch("clients/dynamicTitleInfo");
      }
    }, 60000);
    if (this.ForTitleInfo) {
      if (this.ForTitleInfo.length > 0) {
        document.title =
          this.kFormatter(this.ForTitleInfo[0]) +
          " " +
          "|" +
          " " +
          this.kFormatter(this.ForTitleInfo[1]) +
          " " +
          "|" +
          " " +
          this.kFormatter(this.ForTitleInfo[2]) +
          " " +
          "AstraQ";
      }
    } else {
      document.title = "AstraQ";
    }
  },
  methods: {
    kFormatter: function(num) {
      if (num > 0) {
        return Math.abs(num) > 999
          ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
          : Math.sign(num) * Math.abs(num);
      } else {
        return 0;
      }
    }
  }
};
</script>

<style lang="scss">
html, body {
  background: #ffffff !important;
  margin: 0;
  padding: 0;
}

.blind {
  filter: grayscale(65%) !important;
}

.app-shell {
  display: flex;
  min-height: 100vh;
  background: #fff;
}

.app-content {
  flex: 1;
  min-width: 0;
  background: #fff;
}

@media (max-width: 767px) {
  .app-content {
    margin-left: 0 !important;
    overflow-x: hidden;
    max-width: 100vw;
  }
  .mob-hamburger {
    position: fixed;
    top: 10px;
    left: 10px;
    z-index: 1300;
    width: 44px;
    height: 44px;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    color: #374151;
    transition: box-shadow 0.15s;
  }
  .mob-hamburger:hover { box-shadow: 0 4px 12px rgba(0,0,0,0.15); }
  .mob-nav-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.35);
    z-index: 1199;
  }
}
@media (min-width: 768px) {
  .mob-hamburger { display: none !important; }
  .mob-nav-backdrop { display: none !important; }
}

</style>
